import React from 'react';
import { ReceiveFlowContext, defaultValue, } from '../contexts/receiveflow';
export const ReceiveFlowContextProvider = ({ children }) => {
    const [state, setState] = React.useState(defaultValue);
    const value = React.useMemo(() => (Object.assign(Object.assign({}, state), { set: setState })), [state]);
    return (React.createElement(ReceiveFlowContext.Provider, { value: value }, children));
};
